<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="$store.getters.role == 1 || $store.getters.role == 2 || $store.getters.role == 4">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div class="page-name">TV Console</div>
                    <!-- <button type="button" class="btn btn-secondary" v-on:click="exportTicket($event)">Export</button> -->
                </div>

                <!--page content-->
                <div class="admin-page-content">
                    <div class="card">
                        <h5 class="card-header">
                            <div class="selectdate">
                                <div class="selectbox1">
                                    <v-select v-model="selectedLocation" name="location"
                                            placeholder="Type location here"
                                            label="location_name" @input="locationError=''"
                                            :options="locationOptions" class="">
                                    </v-select>
                                    <span class="text-danger">{{locationError}}</span>
                                    <!--<span v-show="errors.has('location')" class="danger">-->
                                        <!--{{ errors.first('location') }}-->
                                    <!--</span>-->
                                </div>
                                <button type="button" class="btn btn-secondary CustomBtnScreen" v-on:click="launchTV($event)">Launch TV Screen</button>
                            </div>
                        </h5>
                    </div>
                    <div class="card">
                        <h5 class="card-header">
                            <div class="selectdate">
                                <div class="selectbox1">
                                    <label for="frontCounter">Front Counter</label>
                                    <v-select v-model="frontCounterLocation" name="frontCounterLocation"
                                            placeholder="Type front counter here"
                                            label="location_name" @input="frontCounterLocationError=''"
                                            :options="locationOptions">
                                    </v-select>
                                    <span class="text-danger">{{frontCounterLocationError}}</span>
                                </div>
                                <div class="selectbox1">
                                    <label for="willCallLocation">Will Call</label>
                                    <v-select v-model="willCallLocation" name="willCallLocation"
                                            placeholder="Type will call here"
                                            label="location_name" @input="willCallLocationError=''"
                                            :options="locationOptions">
                                    </v-select>
                                    <span class="text-danger">{{willCallLocationError}}</span>
                                </div>
                                <div>
                                    <label for="extraLabel"></label>
                                </div>
                                <button type="button" class="btn btn-secondary CustomBtnScreen" style="margin-top: 7px;" v-on:click="launchWaitingWindow($event)">Launch Waiting Window</button>
                            </div>
                        </h5>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <no-permission></no-permission>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import {HTTP} from '../http-common';
    import vSelect from 'vue-select';
    import {commonMixins} from '../mixins/commonMixins';
    import FrontFooter from '@/components/FrontFooter';
    import NoAccessPermission from '@/components/NoAccessPermission'
    import EventBus from "./event-bus";
    var evtSource = false;
    export default {
        name: "TvScreen",
        mixins: [commonMixins],
        components: {
            'v-select': vSelect,
            'app-footer':FrontFooter,
            'no-permission': NoAccessPermission,
        },
        data() {
            return {
                selectedLocation: '',
                locationOptions:[],
                locationName : '',
                closedTicketNumber : '999',
                locationId : '',

                // Frontend Error
                locationError : '',
                frontCounterLocation : '',
                frontCounterLocationError : '',
                willCallLocation : '',
                willCallLocationError : '',
            }
        },

        mounted:function(){
            let self = this;
            let userObj = JSON.parse(localStorage.getItem("user_obj"));
            console.log(self.locationId);
            //return;
            self.loadLocations();
        },
        methods: {
            launchTV: function () {
                let self = this;
                if (self.selectedLocation === "" || self.selectedLocation === null) {
                    self.locationError = "Please Select Location";
                    return false;
                }
                console.log(self.selectedLocation.location_id);
                window.localStorage.setItem("tv_location_id", self.selectedLocation.location_id);
                window.location.href = 'recentclosedticket';
                /*window.localStorage.setItem("tv_location_id", self.selectedLocation.location_id);
                // window.location.href = 'recentclosedticket';
                window.open(
                    'recentclosedticket',
                    '_blank' // <- This is what makes it open in a new window.
                );*/
            },
            launchWaitingWindow: function () {
                let self = this;
                var error = true;
                if (self.frontCounterLocation === "" || self.frontCounterLocation === null) {
                    self.frontCounterLocationError = "Please Select Front Counter";
                    error = false;
                }
                if (self.willCallLocation === "" || self.willCallLocation === null) {
                    self.willCallLocationError = "Please Select Will Call";
                    error = false;
                }
                if(error) {
                    window.localStorage.setItem("front_counter_location_id", self.frontCounterLocation.location_id);
                    window.localStorage.setItem("will_call_location_id", self.willCallLocation.location_id);
                    window.open('ticketwaitingwindow','_blank'); // <- This is what makes it open in a new window.
                }
            },
            onchangeLocation : function () {
                let self = this;
                self.locationError = '';
            },
            changeLocation : function () {
                $('#recentClosedTicket').modal('show');
            },
            checkForm: function () {
                let self = this;
                var checked = true;
                if (!self.selectedLocation) {
                    self.locationError = "Location Required";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            updateLocation : function () {
                let self = this;
                if (self.checkForm()) {
                    $('#recentClosedTicket').modal('hide');
                    self.initEventSource();
                    self.locationName = self.selectedLocation.location_name;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/TvScreen.vue